var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.53125V8.95125C22 10.5312 21 11.5312 19.42 11.5312H16V4.54125C16 3.43125 16.91 2.53125 18.02 2.53125C19.11 2.54125 20.11 2.98125 20.83 3.70125C21.55 4.43125 22 5.43125 22 6.53125Z",
    fill: "#FF8F53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2 7.53125V21.5312C2 22.3612 2.94001 22.8312 3.60001 22.3312L5.31 21.0513C5.71 20.7513 6.27 20.7913 6.63 21.1513L8.28999 22.8213C8.67999 23.2113 9.32001 23.2113 9.71001 22.8213L11.39 21.1413C11.74 20.7913 12.3 20.7513 12.69 21.0513L14.4 22.3312C15.06 22.8212 16 22.3512 16 21.5312V4.53125C16 3.43125 16.9 2.53125 18 2.53125H7H6C3 2.53125 2 4.32125 2 6.53125V7.53125Z",
    fill: "#FF8F53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon2);
export default __webpack_public_path__ + "static/media/feature-icon-2.2db5c7f00362ffeb2334053afeb06703.svg";
export { ForwardRef as ReactComponent };